import { Chip } from '@mui/material';
import { 
  CheckCircle as CheckCircleIcon,
  Pause as PauseIcon,
  Archive as ArchiveIcon,
} from '@mui/icons-material';

const StatusChip = ({ status }) => {
  const statusConfig = {
    ACTIVE: {
      color: 'success',
      label: 'Active',
      icon: <CheckCircleIcon fontSize="small" />,
    },
    PAUSED: {
      color: 'warning',
      label: 'Paused',
      icon: <PauseIcon fontSize="small" />,
    },
    ARCHIVED: {
      color: 'default',
      label: 'Archived',
      icon: <ArchiveIcon fontSize="small" />,
    },
  };

  const config = statusConfig[status];

  return (
    <Chip 
      icon={config.icon} 
      label={config.label} 
      color={config.color} 
      size="small" 
    />
  )
};

export default StatusChip;